/**
 @ngdoc directive
 @name feeSchedules

 @description
 renders repeating rows for the Fee Schedule Assignment table in Core Configuration->Organisation Units

 @usage
 <tbody fee-schedules
 supplier-group-list="${supplierGroupList as JSON}"
 fee-schedule-list="${feeScheduleList as JSON}"
 fee-schedule-assignment-instance-list="${feeScheduleAssignmentInstanceListAsJSON}"
 has-fee-schedules-view-permission="${hasFeeSchedulesViewPermission}"
 container-id="'${containerId}'"
 supplier-group-map="${supplierGroupMap as JSON}"
 fee-schedule-map="${feeScheduleMap as JSON}"
 read-only="${readOnly}"
 >

 @param {supplier-group-list}                       JSON object     - list of supplier groups, from FeeScheduleAssignmentService, used to populate 'Applies to' checkbox list
 @param {fee-schedule-list}                         JSON object     - list of fee schedules, from FeeScheduleAssignmentService, used to populate Fee Schedules select boxes
 @param {fee-schedule-assignment-instance-list}     JSON object     - list of instances for organisation unit, from FeeScheduleAssignmentService, used to populate each row specific to organisation unit
 @param {has-fee-schedules-view-permission}         boolean         - boolean representation of xsec:access for feeSchedules/view
 @param {supplier-group-map}                        JSON object     - hashmap of supplier groups, from FeeScheduleAssignmentService, used to populate read-only 'Applies to' list
 @param {fee-schedule-map}                          JSON object     - hashmap of fee schedules, from FeeScheduleAssignmentService, used to populate read-only Fee Schedules lists
 @param {read-only}                                 boolean         - if true, the fee schedule cannot be edited

 * */
(function () {
    'use strict';
    var feeSchedules = function ($templateCache, $http, i18nService, ajaxCall) {
        return {
            restrict: 'EA',
            scope: {
                supplierGroupList: '<supplierGroupList',
                hasFeeSchedulesViewPermission: '<hasFeeSchedulesViewPermission',
                feeScheduleAssignmentInstanceList: '<feeScheduleAssignmentInstanceList',
                feeScheduleList: '<feeScheduleList',
                readOnly: '<readOnly',
                supplierGroupMap: '<supplierGroupMap',
                feeScheduleMap: '<feeScheduleMap'
            },
            bindToController: {
                init: '&'
            },
            controllerAs:'ctrl',
            template: $templateCache.get('formWidget/feeSchedules.html'),
            controller: function($scope) {

                var _this = this;

                this.$onInit = function(){
                    _this.spacer = WEBAPP_PATH + '/images/spacer.gif';
                    _this.i18nService = i18nService.preLoadI18nValues({
                        'default.view.label': 'View',
                        'default.add.label': 'Add',
                        'default.remove.label': 'Remove',
                        'default.pleaseSelect.label': 'Please select',
                        'feeScheduleAssignment.supplierOrgId.label': 'Applies To',
                        'feeScheduleAssignment.feeScheduleConfigId.label': 'Supplier Fee Schedule',
                        'feeScheduleAssignment.mspFeeScheduleConfigId.label': 'MSP Fee Schedule',
                        'feeScheduleAssignment.thirdpaFeeScheduleConfigId.label': 'Third Party Fee Schedule'
                    });
                };

                $scope.idsMap = function(feeScheduleList){
                    var mappedIds = [];
                    var i;
                    for(i = 0; i < feeScheduleList.length; i++){
                        mappedIds.push(feeScheduleList[i].id);
                    }
                    return mappedIds;
                };

                $scope.deleteRow = function(index){
                    ajaxCall.getData(WEBAPP_PATH + '/feeScheduleAssignment/deleteRowAngular', {rowIndex:index})
                        .then(function() {
                            $scope.feeScheduleAssignmentInstanceList.splice(index, 1);
                        });
                };

                $scope.addRow = function(){
                    $scope.feeScheduleAssignmentInstanceList.push({});
                };

            },
        };
    };
    feeSchedules.$inject = ['$templateCache','$http', 'i18nService', 'ajaxCall'];
    angular.module('app').directive('feeSchedules',feeSchedules);
}());